import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import React from "react";
import { Outlet } from "react-router-dom";

const SidebarLayout = () => {
  return (

        <div className="tab-content h-full">
          <Outlet />
        </div>

  );
};

export default SidebarLayout;
